import React from 'react';
import { TextField, Autocomplete } from '@mui/material';

export default class Caratula extends React.Component{
  constructor(props){
    super(props);
    this.state={}
  }

  validarFecha(campo, valor){
    const previo = this.props.datos[campo];
    const longitud = valor.length;
    const longitudPrevio = previo.length;
    if (longitud < longitudPrevio)
      return this.props.editar(campo,valor);
    if (!isNaN(valor[longitud-1]) && longitud < 11 && valor[longitud-1] !== " "){
      if (longitud === 2 || longitud === 5)
        valor += "/";
      this.props.editar(campo,valor)
    }
  }

  validarAnio(campo, valor){
    const previo = this.props.datos[campo];
    const longitud = valor.length;
    const longitudPrevio = previo.length;
    if (longitud < longitudPrevio)
      return this.props.editar(campo,valor);
    if (!isNaN(valor[longitud-1]) && longitud < 5 && valor[longitud-1] !== " "){
      this.props.editar(campo,valor)
    }
  }

  render(){
    const {caratula, fecha, numero, numero_exp, anio_exp, categoriaSelec} = this.props.datos;
    const {categorias, editar} = this.props;
    return(
      <div style={{width:'100%', borderRadius:10, backgroundColor:'white', padding:10, margin:10, display:'flex', flexDirection:'column'}}>
        <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
          <TextField
            size="small"
            style={{flex:1,textAlign:'center',minWidth:0,margin:'5px 1px'}}
            label="Carátula"
            value={caratula}
            onChange={(e) => editar("caratula",e.target.value)}
            variant="outlined"
          />
        </div>
        <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
          <TextField
            size="small"
            style={{flex:1,textAlign:'center',minWidth:0,margin:'5px 1px'}}
            label="Fecha de caratula"
            value={fecha}
            placeholder='DD/MM/AAAA'
            onChange={(e) => this.validarFecha('fecha', e.target.value)}
            variant="outlined"
          />
          <TextField
            size="small"
            style={{flex:1,textAlign:'center',minWidth:0,margin:'5px 1px'}}
            label="Nro Oficio"
            value={numero}
            placeholder='Opcional'
            onChange={(e) => editar("numero",e.target.value)}
            variant="outlined"
          />
          <Autocomplete
            value={categoriaSelec}
            onChange={(e,n) => editar('categoriaSelec',n)}
            isOptionEqualToValue={(option, value) => option.id === value.id }
            options={categorias}
            getOptionLabel={(option) => option.descripcion}
            size="small"
            disableClearable
            style={{margin:'5px 1px',flex:1, fontSize:5}}
            fontSize="small"
            renderInput={(params) => <TextField {...params} label="Categorías"/>}
          />
        </div>
        <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
          <TextField
            size="small"
            style={{flex:1,textAlign:'center',minWidth:0,margin:'5px 1px'}}
            label="Nro Expediente"
            value={numero_exp}
            onChange={(e) => editar('numero_exp',e.target.value)}
            variant="outlined"
          />
          <TextField
            size="small"
            style={{flex:1,textAlign:'center',minWidth:0,margin:'5px 1px'}}
            label="Año Expediente"
            value={anio_exp}
            placeholder='AAAA'
            onChange={(e) => this.validarAnio('anio_exp', e.target.value)}
            variant="outlined"
          />
        </div>
        <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
        </div>
      </div>
    )
  }
}